import { Chip, Link } from '@mui/material';
import { List, useListContext } from 'react-admin';
import moment from 'moment';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';

const STATUS_COLOR: Record<string, 'default' | 'warning' | 'info' | 'success' | 'error'> = {
    PENDING: 'warning',
    PROCESSING: 'info',
    COMPLETED: 'success',
    FAILED: 'error',
};

const columns: CommonListColumn[] = [
    { label: 'ID', field: 'id' },
    { label: 'Campaign Name', field: 'cohortName' },
    {
        label: 'Status',
        render: (row: any) => (
            <Chip label={row.status} color={STATUS_COLOR[row.status] ?? 'default'} size="small" />
        ),
    },
    { label: 'Success', field: 'successCount' },
    { label: 'Failure', field: 'failureCount' },
    {
        label: 'Created At',
        nowrap: true,
        render: (row: any) => moment(row.createdAt).format('DD MMM YYYY, hh:mm A'),
    },
    {
        label: 'Sheet Link',
        stopRowClick: true,
        render: (row: any) => (
            <Link href={row.sheetLink} target="_blank" rel="noreferrer">View Sheet</Link>
        ),
    },
];

const CohortDatagrid = () => {
    const { data, isLoading } = useListContext();

    return (
        <CommonListTable
            title="Bulk Promotional Balance"
            columns={columns}
            data={data ?? []}
            loading={isLoading}
            emptyText="No cohorts yet"
        />
    );
};

const BulkPromotionalBalanceList = (props: any) => (
    <List
        {...props}
        sort={{ field: 'createdAt', order: 'DESC' }}
        sx={{
            "& .RaList-content": {
                boxShadow: "none",
                backgroundColor: "transparent",
            },
        }}
    >
        <CohortDatagrid />
    </List>
);

export default BulkPromotionalBalanceList;
